import { useMutation, type UseMutationResult } from '@tanstack/react-query';
import { downloadContentSelectionExport } from '@/api/content-api';

function exportFilename(): string {
  return `vivport-export-${new Date().toISOString().slice(0, 10)}.zip`;
}

export function useContentExport(): UseMutationResult<void, Error, number[]> {
  return useMutation<void, Error, number[]>({
    mutationFn: (contentIds: number[]) =>
      downloadContentSelectionExport(contentIds, exportFilename()),
  });
}
